'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var zoomOut = {
  from: {
    opacity: 1
  },
  '50%': {
    opacity: 0,
    transform: (0, _utils.scale3d)(0.3, 0.3, 0.3)
  },
  to: {
    opacity: 0
  }
};
exports.default = zoomOut;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/zoom-out.js
// module id = 813
// module chunks = 0